// extracted by mini-css-extract-plugin
export default {"pagination":"styles-module--pagination--3hw8H","pagination__numbers":"styles-module--pagination__numbers--3XI18"};